import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M21.3171 18.525L16.8221 14.02C17.5151 12.842 17.9111 11.466 17.9111 10C17.9111 5.644 14.3661 2.099 10.0001 2.099C5.64412 2.099 2.09912 5.644 2.09912 10C2.09912 14.366 5.64412 17.911 10.0001 17.911C11.4651 17.911 12.8421 17.515 14.0201 16.822L18.5251 21.317C18.9111 21.703 19.4161 21.901 19.9211 21.901C20.4261 21.901 20.9311 21.703 21.3171 21.317C22.0991 20.545 22.0991 19.297 21.3171 18.525ZM10.0001 15.436C7.01012 15.436 4.57412 13 4.57412 10C4.57412 7.01 7.01012 4.574 10.0001 4.574C13.0001 4.574 15.4361 7.01 15.4361 10C15.4361 13 13.0001 15.436 10.0001 15.436Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'SearchFill');

export default Icon;
